// extracted by mini-css-extract-plugin
module.exports = {"container":"RankingType_container__1hKd-","heading":"RankingType_heading__YQzHd","options_list":"RankingType_options_list__sKIri"};